
(function($) {
  'use strict';
  $(document).on('ready', function() {

    $('.from-now').each( function( ) {
      var time_text = '';
      var target_time = parseInt( $(this).data('time') );
      var now_time =  new Date().getTime() / 1000 ;
      var time = target_time - now_time;
      if ( time < 0 ) {
        return;
      }
      var sec = time;
      var min = Math.ceil( sec / 60 );
      var hour = Math.floor( min / 60 );
      var days = Math.floor( hour / 24 );
      //console.log( 'from-now',target_time, now_time, time, sec, min, hour, days );

      if ( days > 0 ) {
        time_text = days + '日と' + (hour-24*days) + '時間';
      } else if ( hour > 0 ) {
        time_text = hour + '時間' + (min-60*hour) + '分';
      } else if ( min > 0 ) {
        time_text = min + '分';
      } else {
        time_text = sec + '秒';
      }
      $(this).html( time_text );
    });
  });

})(jQuery);
